"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _Icon = _interopRequireDefault(require("./Icon/Icon"));

var styles = {
  icon: {
    minWidth: 16,
    fontSize: 26,
    mr: 4
  }
};

var ExpandIcon = function ExpandIcon(_ref) {
  var isExpanded = _ref.isExpanded,
      _ref$sx = _ref.sx,
      sx = _ref$sx === void 0 ? [] : _ref$sx,
      overrideProps = (0, _objectWithoutProperties2["default"])(_ref, ["isExpanded", "sx"]);
  var icon = ['far', isExpanded ? 'angle-down' : 'angle-right'];
  return /*#__PURE__*/_react["default"].createElement(_Icon["default"], (0, _extends2["default"])({
    sx: [styles.icon].concat((0, _toConsumableArray2["default"])(Array.isArray(sx) ? sx : [sx])),
    color: "grey",
    icon: icon
  }, overrideProps));
};

var _default = /*#__PURE__*/(0, _react.memo)(ExpandIcon);

exports["default"] = _default;